import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ringtone from 'modules/common/media/FEMI-Telehealth-Incoming_Call.mp3';

import { Icon, Button } from 'shared/components';
import { getTranslatedUserTitle } from 'modules/user/utils/user';

import theme from './ModalStartConsultation.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  clinician: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    department: PropTypes.string,
  }).isRequired,
  healthcareName: PropTypes.string,
  callerName: PropTypes.string,
  isAcceptCallDisabled: PropTypes.bool.isRequired,
  assignedToGroup: PropTypes.bool,

  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isDialer: PropTypes.bool.isRequired,
};

const defaultProps = {
  healthcareName: '',
  assignedToGroup: false,
  callerName: null,
};

const ModalStartConsultation = ({
  intl,
  clinician,
  healthcareName,
  assignedToGroup,
  onOk,
  onCancel,
  isAcceptCallDisabled,
  isDialer,
  callerName,
}) => (
  <div className={ theme.root }>
    <div className={ theme.header }>
      <div className={ theme.iconContainer }>
        <Icon className={ theme.icon } name="phone-rings" />
      </div>
      <div>
        <Choose>
          <When condition={ assignedToGroup }>
            <FormattedMessage id="General.ProvidersGroup" defaultMessage="** Providers group" />
          </When>

          <When condition={ !assignedToGroup && clinician && clinician.title }>
            <FormattedMessage { ...getTranslatedUserTitle(clinician.title) } />
          </When>

          <When condition={ assignedToGroup }>
            <FormattedMessage id="General.Doctor" defaultMessage="** Doctor" />
          </When>
        </Choose>
        { ' ' }
        <FormattedMessage
          id="app.startConsultationModal.heading"
          defaultMessage="** { clinicianFirstName } { clinicianLastName } is calling..."
          values={{
            clinicianFirstName:
              isDialer
                ? callerName || healthcareName
                : assignedToGroup
                  ? intl.formatMessage({
                    id: 'General.ProvidersGroup',
                    defaultMessage: '** Providers group',
                  })
                  : clinician.firstName,
            clinicianLastName: !assignedToGroup && !isDialer
              ? clinician.lastName
              : null,
          }}
        />
      </div>
      <button
        onClick={ onCancel }
        className={ theme.closingIconContainer }
        aria-label={ intl.formatMessage({ id: 'IncomingCallDialog.IgnoreButton.TitleAttribute', defaultMessage: '** Ignore incoming call' }) }
      >
        <Icon name="naked-x" />
      </button>
    </div>

    <div className={ theme.content }>
      <If condition={ !isDialer }>
        { !assignedToGroup && clinician && clinician.title && <FormattedMessage { ...getTranslatedUserTitle(clinician.title) } /> }
        { ' ' }
        <FormattedMessage
          id="app.startConsultationModal.content"
          defaultMessage="** { clinicianFirstName } { clinicianLastName } from { clinicianDepartment } - { clinicianHealthcareName } is calling."
          values={{
            clinicianFirstName:
              assignedToGroup
                ? intl.formatMessage({
                  id: 'General.ProvidersGroup',
                  defaultMessage: '** Providers group',
                })
                : clinician.firstName,
            clinicianLastName: !assignedToGroup
              ? clinician.lastName
              : null,
            clinicianDepartment: !assignedToGroup
              ? clinician.department
              : null,
            clinicianHealthcareName: healthcareName,
          }}
        />
      </If>
    </div>

    <div className={ theme.footer }>
      <Button
        testId="modal-start-consultation-decline-button"
        label={ intl.formatMessage({
          id: 'app.startConsultationModal.cancelButton',
          defaultMessage: '** Ignore',
        }) }
        ariaLabel={ intl.formatMessage({
          id: 'IncomingCallDialog.IgnoreButton.TitleAttribute',
          defaultMessage: '** Ignore incoming call',
        }) }
        className={ theme.cancelButton }
        iconName="hangout"
        background="red"
        onClick={ onCancel }
        iconPositionLeft
      />

      <Button
        testId="modal-start-consultation-start-button"
        label={ intl.formatMessage({
          id: 'app.startConsultationModal.okButton',
          defaultMessage: '** Answer',
        }) }
        ariaLabel={ intl.formatMessage({
          id: 'IncomingCallDialog.AnswerButton.TitleAttribute',
          defaultMessage: '** Answer incoming call',
        }) }
        iconName="answer"
        disabled={ isAcceptCallDisabled }
        background="greenMedium"
        onClick={ onOk }
        iconPositionLeft
      />

      <audio
        playsInline
        autoPlay
        loop
        src={ ringtone }
      />
    </div>
  </div>
);

ModalStartConsultation.propTypes = propTypes;
ModalStartConsultation.defaultProps = defaultProps;

export default ModalStartConsultation;
